import { PipeTransform } from '@angular/core';
var SchoolNamePipe = /** @class */ (function () {
    function SchoolNamePipe() {
    }
    SchoolNamePipe.prototype.transform = function (schoolnumber, Schools, ShowNumber) {
        if (!schoolnumber) {
            return '';
        }
        var entry = (Schools || []).find(function (s) { return s.SchoolNumber === schoolnumber; });
        if (entry && !!entry.SchoolName) {
            return "" + entry.SchoolName + (ShowNumber === true ? " (" + entry.SchoolNumber + ")" : '');
        }
        else {
            return schoolnumber;
        }
    };
    return SchoolNamePipe;
}());
export { SchoolNamePipe };
